import { put, takeLatest, call } from 'redux-saga/effects';
import { purgeTokens } from '../actions';
import { LOGOUT_USER } from '../constants';

const createLogoutSaga = (api) => {
  function* logoutSaga() {
    yield call(api.logOutAdmin);
    yield put(purgeTokens());
  }

  function* watchLogout() {
    yield takeLatest(LOGOUT_USER, logoutSaga);
  }
  return {
    watchLogout,
  };
};

export default createLogoutSaga;



// WEBPACK FOOTER //
// ./src/js/redux/sagas/logoutSaga.js